import { SBaseDisplay } from '@summit/core';
import { NumberFormatter } from '@summit/models';

import { EboObject } from '../base-classes/ebo-object';
import { Route } from './route';

export class RouteRun extends EboObject implements SBaseDisplay {
  name: string;
  routeId: string;
  route: Route;
  num: number;
  comment: string;

  constructor(jsonData: Partial<RouteRun>) {
    super(jsonData);
    if (jsonData?.route) this.route = new Route(jsonData.route);
  }

  get defaultSort(): string {
    return `${NumberFormatter(this.num, 2)}-${this.name}`;
  }

  toShortString(): string {
    if (this.route) return `${this.route.name}: ${this.name ?? `Run #${this.num}`}`;
    return `${this.name ?? `Run #${this.num}`}`;
  }
}
